<template>
  <div class="order-company-config-container" v-loading="loading">
    <div v-for="item in list" :key="item.label" class="item">
      <order-company-save v-if="userAuth.can_do_pt_company" :key="item.label" :obj="item" @success="getData"/>
      <div class="item-type config-module">
        <span class="item-type-name">{{ item.type_name || '' }}</span>
        <div class="flex default-config">
          <span>默认承接乙方：</span>
          {{ item.default_company_name || '未设置' }}
        </div>
      </div>
      <div class="config-module">
        <div style="margin-bottom: 8px;">允许指派乙方（多个）</div>
        <ul v-if="item.companies&&item.companies.length">
          <li v-for="company in item.companies" :key="company.company_id" class="company-li">
            {{ company.company_name || '' }}
          </li>
        </ul>
        <div v-else style="color: #8a8e99">未设置</div>
      </div>
    </div>
    <div style="height: 40px;"/>
  </div>
</template>
<script>
import {getCompanyOtList} from "@/api/company";
import OrderCompanySave from "@/views/company/components/order-company-save.vue";

export default {
  name: "OrderCompanyConfig",
  components: {OrderCompanySave},
  data() {
    return {
      list: [],
      loading: false,
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData: async function () {
      this.loading = true
      const {model} = await getCompanyOtList()
      this.loading = false
      this.list = model || []
    }
  }
}

</script>
<style lang="scss">
.order-company-config-container {
  width: calc(100% - 25% - 80px);
  min-height: calc(100vh - 104px);
  //overflow-y: auto;

  .item {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;
    //box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1);
    padding: 20px;
    border-radius: 12px;
    font-size: 14px;
    position: relative;
  }

  .item-btn {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .item + .item {
    margin-top: 20px;
  }

  .flex {
    display: flex;
  }

  .default-config {
    margin-left: 40px;
  }

  .item-type {
    display: flex;
    align-items: center;
  }

  .item-type-name {
    font-weight: bold;
    font-size: 16px;
  }

  .config-module + .config-module {
    margin-top: 10px;
  }

  .config-module ul {
    display: flex;
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    padding: 10px 20px;
    background: rgba(255, 249, 250, 1);
    border-radius: 12px;
    border: 1px solid #E5E7EB;

    li {
      list-style: none;
      background: rgba(255, 49, 118, 1);
      padding: 2px 12px;
      border-radius: 16px;
      color: #fff;
      font-size: 12px;
    }

    li + li {
      margin-left: 12px;
    }
  }
}
</style>
